// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-info-section {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.model-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.model-info-row label {
  width: 200px;
  font-weight: bold;
  margin-right: 10px;
}

.model-info-input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: white;
  transition: border-color 0.3s ease;
}

.model-info-input:focus {
  border-color: #007bff;
  outline: none;
}

.model-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px;
}

.model-card {
  width: 16%;
  min-width: 250px;
  padding: 1.5em;
  border: none !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  position: relative;
  margin-bottom: 1.25em;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
}

.model-card:hover {
  transform: translateY(-8px) !important;
  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.15) !important;
}

.model-card-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: auto; /* 让 footer 始终靠底 */
  padding-top: 8px;
  border-top: 1px solid #ddd;
}

.model-card h3 {
  font-size: min(1.2em, 2.5vw);
  font-weight: 600;
  line-height: 1.2; 
  margin-top: 0; 
  margin-bottom: 0.5em; 
  max-width: 100%; 
  word-wrap: break-word; 
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.model-card p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  color: #4a5568;
  overflow: hidden;
  text-overflow: ellipsis;
}

.model-card-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid #ddd;
}

/* NEF表单样式 */
.nef-form {
  padding: 20px 0;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.form-row label {
  width: 150px;
  font-weight: bold;
  margin-right: 15px;
  text-align: right;
}

.form-input,
.form-select,
.form-textarea {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-checkbox {
  margin-left: 0;
  transform: scale(1.2);
}

.form-textarea {
  resize: vertical;
  min-height: 60px;
}

.wider-modal {
  min-width: 600px;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 20;
  width: 28px;
  height: 28px;
  padding: 0 !important;
  border: none;
  border-radius: 8px;
  background: transparent !important;
  color: #94a3b8;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  opacity: 0 !important;
  pointer-events: none;
  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease !important;
}

.model-card:hover .close-btn {
  opacity: 0.7 !important;
  pointer-events: auto;
}

.close-btn:hover {
  background: #fde8e8 !important;
  color: #d14343 !important;
  opacity: 1 !important;
  transform: none !important;
}

.result-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);
}

.result-btn:hover {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(76, 175, 80, 0.4);
}

/* JSON显示区域 */
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
}

.wider-modal .modal-dialog {
    max-width: 50%; /* 根据需要调整宽度，这里假设原来宽度是 500px，现在加宽一倍为 1000px */
}

/* 分组功能相关样式 */
.nav-tabs {
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 20px;
}

.nav-tabs .nav-link {
  color: #666;
  font-weight: 500;
  padding: 12px 20px;
  border: none;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  cursor: pointer;
}

.nav-tabs .nav-link:hover {
  color: #667eea;
  background-color: rgba(102, 126, 234, 0.05);
  border-radius: 8px 8px 0 0;
}

.nav-tabs .nav-link.active {
  color: #667eea;
  font-weight: 600;
  background-color: transparent;
  border-bottom: 3px solid #667eea;
}

/* 复选框样式 */
.form-check-input {
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-check-input:checked {
  background-color: #667eea;
  border-color: #667eea;
}

.form-check-input:hover {
  border-color: #667eea;
}

/* 标签页关闭按钮 */
.nav-tabs .btn-close {
  font-size: 1em !important;
  padding: 0;
  margin-left: 8px;
  opacity: 1 !important;
  width: 1em;
  height: 1em;
  transition: all 0.2s ease;
}

.nav-tabs .btn-close:hover {
  opacity: 1 !important;
  transform: scale(1.15);
  background-color: #dc3545 !important;
}

.nef-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.model-page-header {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding: 20px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.model-page-eyebrow {
  color: #2563eb;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.model-page-header h1 {
  margin: 4px 0 6px;
  color: #0f172a;
  font-size: 28px;
  font-weight: 800;
}

.model-page-header p {
  max-width: 680px;
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.model-page-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(96px, 1fr));
  gap: 10px;
  min-width: 420px;
}

.model-page-stats div {
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
}

.model-page-stats span,
.model-meta-grid span,
.model-card-kicker {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.model-page-stats strong {
  display: block;
  margin-top: 4px;
  color: #0f172a;
  font-size: 22px;
  line-height: 1;
}

.model-workspace-toolbar,
.model-tabs-panel {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.model-workspace-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px;
}

.model-toolbar-actions {
  display: flex;
  gap: 10px;
}

.group-button,
.delete-selected-button,
.result-btn {
  min-height: 38px;
  border-radius: 10px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  box-shadow: none !important;
  transition: transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}

.group-button {
  border: 1px solid #bfdbfe !important;
  background: #eff6ff !important;
  color: #1d4ed8 !important;
}

.delete-selected-button {
  border: 1px solid #fecdd3 !important;
  background: #fff1f2 !important;
  color: #be123c !important;
}

.group-button:hover:not(:disabled),
.delete-selected-button:hover:not(:disabled),
.result-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.model-tabs-panel {
  padding: 14px;
}

.model-tabs-panel .nav-tabs {
  margin-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.model-tabs-panel .nav-tabs .nav-link {
  color: #475569;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 13px;
  font-weight: 800;
}

.model-tabs-panel .nav-tabs .nav-link.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  background: transparent;
}

.model-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  padding: 0;
}

.model-card {
  width: auto;
  min-width: 0;
  padding: 18px;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px !important;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05) !important;
  text-align: left;
}

.model-card:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.09) !important;
}

.model-card-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-left: 28px;
  padding-right: 36px;
}

.model-card h3 {
  margin: 3px 0 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 800;
}

.model-status-badge {
  align-self: flex-start;
  padding: 4px 9px;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.status-succeeded {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.status-failed {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.status-pending,
.status-running {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.model-meta-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 16px 0 12px;
}

.model-meta-grid div {
  min-width: 0;
  padding: 9px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  background: #f8fafc;
}

.model-meta-grid strong {
  display: block;
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.model-card-footer {
  align-items: stretch;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.result-btn {
  width: 100%;
  border: 1px solid #bfdbfe !important;
  background: #2563eb !important;
  color: #ffffff !important;
}

.model-empty-state {
  grid-column: 1 / -1;
  padding: 36px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
  font-weight: 700;
}

.model-workspace-toolbar {
  min-height: 58px;
  gap: 12px;
}

.model-toolbar-actions {
  align-items: center;
  gap: 12px;
}

.model-workspace-toolbar .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  min-height: 40px;
  padding: 9px 16px !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.wider-modal .modal-dialog {
  max-width: 760px;
}

.nef-generate-modal .modal-dialog {
  max-width: 420px;
}

.nef-generate-modal .modal-header {
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
}

.nef-generate-modal .modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.nef-generate-modal .modal-body {
  padding: 16px;
}

.nef-generate-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nef-generate-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nef-generate-field label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.nef-generate-field input {
  width: 120px;
  max-width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #d8e0ec;
  background: #fff;
  color: #334155;
}

.nef-generate-field input:focus {
  outline: none;
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.2);
}

.nef-generate-modal .org-modal-footer {
  padding: 12px 16px;
}

.model-card {
  border: 1px solid #e6edf7 !important;
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04) !important;
}

.model-card:hover {
  transform: none !important;
  border-color: #bfdbfe !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;
}

.model-card-header .org-role-badge {
  align-self: flex-start;
  margin-top: 4px;
  font-size: 11px;
}

.model-card-footer .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.model-card-link-row {
  margin-top: 0;
}

.model-card-corner-links {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.model-card-corner-left {
  text-align: left;
}

.model-card-corner-right {
  margin-left: auto;
  text-align: right;
}

.model-card-text-link {
  padding: 0;
  border: none;
  background: none;
  color: #2563eb;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}

.model-card-text-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.model-workspace-toolbar .org-btn {
  min-height: 40px;
  padding: 9px 16px;
  font-size: 13px;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .model-page-header {
    flex-direction: column;
  }

  .model-page-stats {
    min-width: 0;
  }
}

@media (max-width: 600px) {
  .model-page-header,
  .model-workspace-toolbar,
  .model-tabs-panel {
    padding: 14px;
  }

  .model-page-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .model-workspace-toolbar,
  .model-toolbar-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .model-workspace-toolbar .btn {
    width: 100%;
    min-width: 0;
  }

  .model-cards-container,
  .model-meta-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NefPage/NefPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,6DAA6D;EAC7D,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,4DAA4D;EAC5D,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB,EAAE,kBAAkB;EACpC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,qFAAqF;AACvF;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;IACI,cAAc,EAAE,4CAA4C;AAChE;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,oFAAoF;AACtF;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".model-info-section {\n  margin-top: 20px;\n  padding: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n}\n\n.model-info-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.model-info-row label {\n  width: 200px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.model-info-input {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  background-color: white;\n  transition: border-color 0.3s ease;\n}\n\n.model-info-input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.model-cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: flex-start;\n  align-items: stretch;\n  padding: 10px;\n}\n\n.model-card {\n  width: 16%;\n  min-width: 250px;\n  padding: 1.5em;\n  border: none !important;\n  border-radius: 12px !important;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n  position: relative;\n  margin-bottom: 1.25em;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  overflow: hidden;\n  \n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: auto;\n}\n\n.model-card:hover {\n  transform: translateY(-8px) !important;\n  box-shadow: 0 12px 24px rgba(102, 126, 234, 0.15) !important;\n}\n\n.model-card-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: auto; /* 让 footer 始终靠底 */\n  padding-top: 8px;\n  border-top: 1px solid #ddd;\n}\n\n.model-card h3 {\n  font-size: min(1.2em, 2.5vw);\n  font-weight: 600;\n  line-height: 1.2; \n  margin-top: 0; \n  margin-bottom: 0.5em; \n  max-width: 100%; \n  word-wrap: break-word; \n  color: #2d3748;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.model-card p {\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  color: #4a5568;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.model-card-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px solid #ddd;\n}\n\n/* NEF表单样式 */\n.nef-form {\n  padding: 20px 0;\n}\n\n.form-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.form-row label {\n  width: 150px;\n  font-weight: bold;\n  margin-right: 15px;\n  text-align: right;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-checkbox {\n  margin-left: 0;\n  transform: scale(1.2);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.wider-modal {\n  min-width: 600px;\n}\n\n.close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 20;\n  width: 28px;\n  height: 28px;\n  padding: 0 !important;\n  border: none;\n  border-radius: 8px;\n  background: transparent !important;\n  color: #94a3b8;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0 !important;\n  pointer-events: none;\n  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease !important;\n}\n\n.model-card:hover .close-btn {\n  opacity: 0.7 !important;\n  pointer-events: auto;\n}\n\n.close-btn:hover {\n  background: #fde8e8 !important;\n  color: #d14343 !important;\n  opacity: 1 !important;\n  transform: none !important;\n}\n\n.result-btn {\n  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  margin-top: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);\n}\n\n.result-btn:hover {\n  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(76, 175, 80, 0.4);\n}\n\n/* JSON显示区域 */\npre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  background: #f8f9fa;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.wider-modal .modal-dialog {\n    max-width: 50%; /* 根据需要调整宽度，这里假设原来宽度是 500px，现在加宽一倍为 1000px */\n}\n\n/* 分组功能相关样式 */\n.nav-tabs {\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 20px;\n}\n\n.nav-tabs .nav-link {\n  color: #666;\n  font-weight: 500;\n  padding: 12px 20px;\n  border: none;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #667eea;\n  background-color: rgba(102, 126, 234, 0.05);\n  border-radius: 8px 8px 0 0;\n}\n\n.nav-tabs .nav-link.active {\n  color: #667eea;\n  font-weight: 600;\n  background-color: transparent;\n  border-bottom: 3px solid #667eea;\n}\n\n/* 复选框样式 */\n.form-check-input {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #d1d5db;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.form-check-input:checked {\n  background-color: #667eea;\n  border-color: #667eea;\n}\n\n.form-check-input:hover {\n  border-color: #667eea;\n}\n\n/* 标签页关闭按钮 */\n.nav-tabs .btn-close {\n  font-size: 1em !important;\n  padding: 0;\n  margin-left: 8px;\n  opacity: 1 !important;\n  width: 1em;\n  height: 1em;\n  transition: all 0.2s ease;\n}\n\n.nav-tabs .btn-close:hover {\n  opacity: 1 !important;\n  transform: scale(1.15);\n  background-color: #dc3545 !important;\n}\n\n.nef-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.model-page-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 20px 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.model-page-eyebrow {\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.model-page-header h1 {\n  margin: 4px 0 6px;\n  color: #0f172a;\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.model-page-header p {\n  max-width: 680px;\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.model-page-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(96px, 1fr));\n  gap: 10px;\n  min-width: 420px;\n}\n\n.model-page-stats div {\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.model-page-stats span,\n.model-meta-grid span,\n.model-card-kicker {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.model-page-stats strong {\n  display: block;\n  margin-top: 4px;\n  color: #0f172a;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.model-workspace-toolbar,\n.model-tabs-panel {\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);\n}\n\n.model-workspace-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px;\n}\n\n.model-toolbar-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.group-button,\n.delete-selected-button,\n.result-btn {\n  min-height: 38px;\n  border-radius: 10px !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  box-shadow: none !important;\n  transition: transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;\n}\n\n.group-button {\n  border: 1px solid #bfdbfe !important;\n  background: #eff6ff !important;\n  color: #1d4ed8 !important;\n}\n\n.delete-selected-button {\n  border: 1px solid #fecdd3 !important;\n  background: #fff1f2 !important;\n  color: #be123c !important;\n}\n\n.group-button:hover:not(:disabled),\n.delete-selected-button:hover:not(:disabled),\n.result-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.model-tabs-panel {\n  padding: 14px;\n}\n\n.model-tabs-panel .nav-tabs {\n  margin-bottom: 14px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.model-tabs-panel .nav-tabs .nav-link {\n  color: #475569;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.model-tabs-panel .nav-tabs .nav-link.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  background: transparent;\n}\n\n.model-cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 14px;\n  padding: 0;\n}\n\n.model-card {\n  width: auto;\n  min-width: 0;\n  padding: 18px;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 16px !important;\n  background: #ffffff;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05) !important;\n  text-align: left;\n}\n\n.model-card:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.09) !important;\n}\n\n.model-card-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding-left: 28px;\n  padding-right: 36px;\n}\n\n.model-card h3 {\n  margin: 3px 0 0;\n  color: #0f172a;\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.model-status-badge {\n  align-self: flex-start;\n  padding: 4px 9px;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.status-succeeded {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.status-failed {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.status-pending,\n.status-running {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.model-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin: 16px 0 12px;\n}\n\n.model-meta-grid div {\n  min-width: 0;\n  padding: 9px;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.model-meta-grid strong {\n  display: block;\n  margin-top: 3px;\n  color: #0f172a;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.model-card-footer {\n  align-items: stretch;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.result-btn {\n  width: 100%;\n  border: 1px solid #bfdbfe !important;\n  background: #2563eb !important;\n  color: #ffffff !important;\n}\n\n.model-empty-state {\n  grid-column: 1 / -1;\n  padding: 36px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 16px;\n  background: #f8fafc;\n  color: #64748b;\n  text-align: center;\n  font-weight: 700;\n}\n\n.model-workspace-toolbar {\n  min-height: 58px;\n  gap: 12px;\n}\n\n.model-toolbar-actions {\n  align-items: center;\n  gap: 12px;\n}\n\n.model-workspace-toolbar .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 140px;\n  min-height: 40px;\n  padding: 9px 16px !important;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.wider-modal .modal-dialog {\n  max-width: 760px;\n}\n\n.nef-generate-modal .modal-dialog {\n  max-width: 420px;\n}\n\n.nef-generate-modal .modal-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.nef-generate-modal .modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  line-height: 1.3;\n}\n\n.nef-generate-modal .modal-body {\n  padding: 16px;\n}\n\n.nef-generate-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nef-generate-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.nef-generate-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.nef-generate-field input {\n  width: 120px;\n  max-width: 100%;\n  padding: 8px 10px;\n  font-size: 14px;\n  border-radius: 8px;\n  border: 1px solid #d8e0ec;\n  background: #fff;\n  color: #334155;\n}\n\n.nef-generate-field input:focus {\n  outline: none;\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.2);\n}\n\n.nef-generate-modal .org-modal-footer {\n  padding: 12px 16px;\n}\n\n.model-card {\n  border: 1px solid #e6edf7 !important;\n  border-radius: 16px !important;\n  background: #ffffff !important;\n  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04) !important;\n}\n\n.model-card:hover {\n  transform: none !important;\n  border-color: #bfdbfe !important;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08) !important;\n}\n\n.model-card-header .org-role-badge {\n  align-self: flex-start;\n  margin-top: 4px;\n  font-size: 11px;\n}\n\n.model-card-footer .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.model-card-link-row {\n  margin-top: 0;\n}\n\n.model-card-corner-links {\n  margin-top: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\n.model-card-corner-left {\n  text-align: left;\n}\n\n.model-card-corner-right {\n  margin-left: auto;\n  text-align: right;\n}\n\n.model-card-text-link {\n  padding: 0;\n  border: none;\n  background: none;\n  color: #2563eb;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.model-card-text-link:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n.model-workspace-toolbar .org-btn {\n  min-height: 40px;\n  padding: 9px 16px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n@media (max-width: 1100px) {\n  .model-page-header {\n    flex-direction: column;\n  }\n\n  .model-page-stats {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .model-page-header,\n  .model-workspace-toolbar,\n  .model-tabs-panel {\n    padding: 14px;\n  }\n\n  .model-page-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .model-workspace-toolbar,\n  .model-toolbar-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .model-workspace-toolbar .btn {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .model-cards-container,\n  .model-meta-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
